var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"space-view"},[_c('SpaceSidebar'),_c('SpacePage',{ref:"spacePage",attrs:{"pageId":_vm.currentPageId}}),_c('FileEditor'),_c('CreateFile'),_c('DeleteModal'),_c('RenameModal'),_c('QuickSwitcher'),_c('AccessErrorPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }